// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: common/websockets.proto

/* eslint-disable */
import type { ContentRewardsMessage } from "../content_rewards_app/content_rewards_app";
import type { ExecuteClientCommand, ExecuteClientCommandResponse } from "../diagnostics/client_commands";
import type { Experience, UserExperience } from "../experience/experience";
import type { PreviewContent } from "../experience/preview_content";
import type { ClientToServerMessage, ServerToClientMessage } from "../games/messages";
import type { FileAttachment } from "./attachment";
import type {
  AccessPass,
  AccessPassExperience,
  AccessPassExperienceSection,
  AccessPassMember,
  App,
  AppBuild,
  Bot,
  BotExperienceSection,
  BroadcastRequest,
  BroadcastResponse,
  BusinessActivityEvent,
  Channel,
  ChannelSubscriptionState,
  ConnectedId,
  DiscoveryAccessPassLiveData,
  Entry,
  GoFetchExperienceList,
  GoFetchUserExperiences,
  MarketplaceStats,
  Member,
  Platform,
  Purchase,
  Reconnect,
  ReloadClient,
  UserReferralMarketRates,
} from "./common";
import type { FeedEntity, SupportTicketBadgeUpdate } from "./feed";
import type { GoFetchNotifications, Notification } from "./notifications";
import type { ActiveUsersInBucket, ProductSurfaceUpdate } from "./product_surface";
import type { User, UserPresence, UserStat } from "./users";

export const ResourceType = {
  RESOURCE_UNKNOWN: "RESOURCE_UNKNOWN",
  RESOURCE_BOT: "RESOURCE_BOT",
  RESOURCE_ACCESS_PASS: "RESOURCE_ACCESS_PASS",
  RESOURCE_EXPERIENCE: "RESOURCE_EXPERIENCE",
  RESOURCE_USER: "RESOURCE_USER",
  RESOURCE_EXPERIENCE_PREVIEW_CONTENT: "RESOURCE_EXPERIENCE_PREVIEW_CONTENT",
  RESOURCE_APP: "RESOURCE_APP",
  RESOURCE_FORUM_FEED: "RESOURCE_FORUM_FEED",
  RESOURCE_UNIVERSAL_POST: "RESOURCE_UNIVERSAL_POST",
  RESOURCE_CHAT_FEED: "RESOURCE_CHAT_FEED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ResourceType = typeof ResourceType[keyof typeof ResourceType];

export namespace ResourceType {
  export type RESOURCE_UNKNOWN = typeof ResourceType.RESOURCE_UNKNOWN;
  export type RESOURCE_BOT = typeof ResourceType.RESOURCE_BOT;
  export type RESOURCE_ACCESS_PASS = typeof ResourceType.RESOURCE_ACCESS_PASS;
  export type RESOURCE_EXPERIENCE = typeof ResourceType.RESOURCE_EXPERIENCE;
  export type RESOURCE_USER = typeof ResourceType.RESOURCE_USER;
  export type RESOURCE_EXPERIENCE_PREVIEW_CONTENT = typeof ResourceType.RESOURCE_EXPERIENCE_PREVIEW_CONTENT;
  export type RESOURCE_APP = typeof ResourceType.RESOURCE_APP;
  export type RESOURCE_FORUM_FEED = typeof ResourceType.RESOURCE_FORUM_FEED;
  export type RESOURCE_UNIVERSAL_POST = typeof ResourceType.RESOURCE_UNIVERSAL_POST;
  export type RESOURCE_CHAT_FEED = typeof ResourceType.RESOURCE_CHAT_FEED;
  export type UNRECOGNIZED = typeof ResourceType.UNRECOGNIZED;
}

export interface WebsocketMessageServerToClient {
  newNotification?: Notification | undefined;
  reconnect?: Reconnect | undefined;
  reloadClient?: ReloadClient | undefined;
  feedEntity?: FeedEntity | undefined;
  heartbeatResponse?: HeartbeatResponse | undefined;
  goFetchNotifications?: GoFetchNotifications | undefined;
  marketplaceStats?: MarketplaceStats | undefined;
  purchase?: Purchase | undefined;
  broadcastResponse?: BroadcastResponse | undefined;
  channelSubscriptionState?: ChannelSubscriptionState | undefined;
  discoveryAccessPassLiveData?: DiscoveryAccessPassLiveData | undefined;
  activeUsersInBucket?: ActiveUsersInBucket | undefined;
  gameMessage?: ServerToClientMessage | undefined;
  contentRewardsMessage?: ContentRewardsMessage | undefined;
  experience?: Experience | undefined;
  accessPassMember?: AccessPassMember | undefined;
  accessPassExperience?: AccessPassExperience | undefined;
  accessPass?: AccessPass | undefined;
  bot?: Bot | undefined;
  experiencePreviewContent?: PreviewContent | undefined;
  user?: User | undefined;
  app?: App | undefined;
  fileAttachment?: FileAttachment | undefined;
  userStat?: UserStat | undefined;
  userExperience?: UserExperience | undefined;
  entry?: Entry | undefined;
  userReferralMarketRates?: UserReferralMarketRates | undefined;
  appMessage?: AppMessage | undefined;
  goFetchExperienceList?: GoFetchExperienceList | undefined;
  appBuild?: AppBuild | undefined;
  accessPassExperienceSection?: AccessPassExperienceSection | undefined;
  goFetchUserExperiences?: GoFetchUserExperiences | undefined;
  member?: Member | undefined;
  botExperienceSection?: BotExperienceSection | undefined;
  userPresence?: UserPresence | undefined;
  businessActivityEvent?: BusinessActivityEvent | undefined;
  executeClientCommand?: ExecuteClientCommand | undefined;
  supportTicketBadgeUpdate?:
    | SupportTicketBadgeUpdate
    | undefined;
  /** [TIMING] When was the message initially created. Eg: timestamp from the rails application. */
  createdAt:
    | string
    | undefined;
  /** [TIMING] When was the message received by the websocket server. (in the GRPC handler) */
  processedAt:
    | string
    | undefined;
  /** [TIMING] When was the message sent to the client by the websocket connection handler. */
  deliveredAt: string | undefined;
}

export interface WebsocketMessageClientToServer {
  heartbeat?: Heartbeat | undefined;
  subscribeToChannel?: SubscribeToChannel | undefined;
  unsubscribeFromChannel?: UnsubscribeFromChannel | undefined;
  broadcastRequest?: BroadcastRequest | undefined;
  productSurfaceUpdate?: ProductSurfaceUpdate | undefined;
  gameCommand?: ClientToServerMessage | undefined;
  subscribeToChannelBatch?: SubscribeToChannelBatch | undefined;
  requestItemsBatchRequest?: RequestItemsBatchRequest | undefined;
  broadcastAppMessage?: BroadcastAppMessage | undefined;
  executeClientCommandResponse?: ExecuteClientCommandResponse | undefined;
}

export interface Heartbeat {
  userish: ConnectedId | undefined;
  channels: Channel[];
  platform: Platform;
  /** Allow the client to send a semantic version number (useful on ios / android) */
  clientSemver: string;
  /** On web, the client can send the age of the client code (aka how long ago they loaded the page) */
  clientAge: string | undefined;
  productSurfaceUpdate?: ProductSurfaceUpdate | undefined;
}

export interface HeartbeatResponse {
  /** Allows clients to find out how delayed they are WRT to true server time. Can detect old devices that do not have synced clocks. */
  serverTime: string | undefined;
}

export interface SubscribeToChannel {
  userish: ConnectedId | undefined;
  channel: Channel | undefined;
  authToken?: string | undefined;
}

export interface SubscribeToChannelBatch {
  channels: SubscribeToChannel[];
}

export interface UnsubscribeFromChannel {
  userish: ConnectedId | undefined;
  channel: Channel | undefined;
}

/**
 * This is a message that is sent by a 3rd party developer
 * that includes an arbitrary body. Used for app developer things.
 */
export interface AppMessage {
  /** If this packet was sent from another user's browser, this is the user id it came from. */
  fromUserId?:
    | string
    | undefined;
  /** this is true if the event is sent with your server side secret api key. */
  isTrusted: boolean;
  /** an arbitrary payload of data. */
  json: string;
}

/** To send a message from an user as an app developer, use this message. */
export interface BroadcastAppMessage {
  /** String encoded JSON object that you want to send from the client. */
  json: string;
  /** Target channel */
  channel: Channel | undefined;
}

export interface SendToTargetRequest {
  target: string;
  /** @deprecated */
  message:
    | WebsocketMessageServerToClient
    | undefined;
  /** Pass the message as a WebsocketMessageServerToClient proto serialized to bytes. */
  messageBytes: Uint8Array;
}

export interface SendToTargetResponse {
  wasTargetConnected: boolean;
}

export interface SendToTargetsRequest {
  targets: string[];
  /** @deprecated */
  message:
    | WebsocketMessageServerToClient
    | undefined;
  /** Pass the message as a WebsocketMessageServerToClient proto serialized to bytes. */
  messageBytes: Uint8Array;
}

export interface SendToTargetsResponse {
  wasTargetConnectedMap: { [key: string]: boolean };
}

export interface SendToTargetsResponse_WasTargetConnectedMapEntry {
  key: string;
  value: boolean;
}

export interface BatchSendToTargetRequest {
  requests: SendToTargetRequest[];
}

export interface BatchSendToTargetResponse {
}

export interface TerminateTargetsRequest {
  targets: string[];
}

export interface TerminateTargetsResponse {
}

/**
 * A command enum that the websocket server receives via GRPC
 * and internally fans out to each horizontal shard
 */
export interface WebsocketServerCommandRequest {
  clearCache?: ClearCacheRequest | undefined;
}

export interface WebsocketServerCommandResponse {
  success: boolean;
  receivedCount: number;
}

/** This is returned from rails when the websocket server wishes to fetch cachable items via http */
export interface BatchGetItemsResponse {
  items: BatchGetItemsResponse_Item[];
}

export interface BatchGetItemsResponse_Item {
  id: string;
  websocketMessageBytes: Uint8Array;
}

/** Sent from a client to instruct the websocket server to send it the data for a certain set of items again. */
export interface RequestItemsBatchRequest {
  items: RequestItemsBatchRequest_Item[];
}

export interface RequestItemsBatchRequest_Item {
  id: string;
  type: ResourceType;
}

export interface ClearCacheRequest {
  ids: string[];
  clearAll?: boolean | undefined;
  cacheType?: ResourceType | undefined;
}

export interface WebsocketService {
  SendToTarget(request: SendToTargetRequest): Promise<SendToTargetResponse>;
  SendToTargets(request: SendToTargetsRequest): Promise<SendToTargetsResponse>;
  BatchSendToTarget(request: BatchSendToTargetRequest): Promise<BatchSendToTargetResponse>;
  TerminateTargets(request: TerminateTargetsRequest): Promise<TerminateTargetsResponse>;
  WebsocketServerCommand(request: WebsocketServerCommandRequest): Promise<WebsocketServerCommandResponse>;
}
